export default __webpack_public_path__ + "static/media/65.ddcd448c.jpeg";